import React from 'react'
import { useSelector } from 'react-redux'
import MeetingAvtor from '../MeetingAvtor'

const MeetingContainerUser = ({ acceptDateMeeting }) => {
  const { chatUser } = useSelector(({ chat }) => chat)

  return (
    <>
      {
        chatUser?.status === 'meeting' && chatUser?.meeting?.status === 'requested' && (
          <MeetingAvtor ofEditIcon onAccept acceptDateMeeting={acceptDateMeeting} />
        )
      }
      {
        chatUser?.status === 'scheduled' && chatUser?.meeting?.status === 'accepted' && (
          <MeetingAvtor ofEditIcon onAccept={false} title='Meeting has been scheduled on:' />
        )
      }
    </>
  )
}

export default MeetingContainerUser
